import WarpElement from '@warp-ds/elements-core';
import { customElement } from 'lit/decorators.js';
import { css, html } from 'lit';
import { i18n } from '@lingui/core';
import { celebratoryMagnifyerSvg } from './consent-illustrations.js';
import '@warp-ds/elements/components/badge';
import pulse from '@finn-no/pulse-sdk';

@customElement('no-history')
export class NoHistory extends WarpElement {
	static styles = [
		...WarpElement.styles,
		css`
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.h2{font-weight:700;font-size:var(--w-font-size-xl);line-height:var(--w-line-height-xl)}.place-self-center{place-self:center}.static{position:static}.max-w-\[624\]{max-width:62.4rem}.mb-24{margin-bottom:2.4rem}.mt-24{margin-top:2.4rem}.pr-4{padding-right:.4rem}@media (width>=768px){.md\:mt-24{margin-top:2.4rem}};
		`,
	];

	fromConsentFlow!: string;

	static properties = {
		locale: { type: String },
		fromConsentFlow: { type: String },
	};

	connectedCallback() {
		super.connectedCallback();
		const locale = this.locale || 'en';
		const messages = JSON.parse(this.getAttribute('translations') || '{}');

		i18n.load(locale, messages);
		i18n.activate(locale);
	}

	firstUpdated() {
		pulse.trackEvent({
			type: 'View',
			intent: 'View',
			name: 'Personalisation consent',
			object: {
				type: 'UIElement',
				name: 'View frontpage personalisation consent success',
				position: 'Frontpage',
			},
			target: {
				type: 'UIElement',
			},
			vertical: {
				name: 'common_pages',
			},
		});
		// Only focus the h2 when navigating from the consent flow
		if (this.fromConsentFlow === 'true') {
			const heading = this.shadowRoot?.getElementById('no-history-heading');
			if (heading) {
				heading.focus();
			}
		}
	}

	render() {
		return html`
			<section class="flex flex-col">
				<div class="place-self-center mt-16 md:mt-24 max-w-[624] justify-items-center">
					<img
						alt="${i18n.t({
							id: 'frontpage.no-history.alt-text.img',
							message: 'Magnifying glass with confetti shapes around it',
						})}"
						src="${celebratoryMagnifyerSvg}"
					/>
					<h2 id="no-history-heading" class="mt-24" tabindex="-1">
						${i18n.t({
							id: 'frontpage.no-history.title',
							message: 'Try searching to get started',
						})}
					</h2>
					<p class="text-center mb-24">
						${i18n.t({
							id: 'frontpage.no-history.text',
							message:
								'Start looking at ads to help us build a feed tailored just for you! If you want to change your choices, go to cookie settings in the footer.',
						})}
					</p>
					<div class="text-center">
						<w-badge variant="positive"
							><w-icon class="pr-4" name="Success" size="small" locale="${this.locale}"></w-icon>${i18n.t({
								id: 'frontpage.no-history.badge.text',
								message: 'Personalisation is on',
							})}</w-badge
						>
					</div>
				</div>
			</section>
		`;
	}
}
